import React, { createContext, useContext, useMemo } from 'react';

import _get from 'lodash/get';

import { AppContext } from 'store/AppContext';

import {
    fetchJitAccessTokenAPINew,
    getPartnerAPI,
    getInitailAccessToken,
} from './auth';
import { getCallAPI } from './call.js';

const ApiContext = createContext();

export const useApi = () => {
    return useContext(ApiContext);
};

// eslint-disable-next-line react/prop-types
function ApiProvider({ children }) {
    const { setInitialAccessToken } = useContext(AppContext);
    const fetchData = async params => {
        try {
            const {
                partnerId,
                requestId,
                access_token: existingAccessToken,
            } = params;
            let access_token = existingAccessToken;

            if (!access_token) {
                const {
                    data: { access_token: newAccessToken },
                } = await getInitailAccessToken();
                access_token = newAccessToken;
            }
            setInitialAccessToken(access_token);
            const {
                data: { data },
            } = await getPartnerAPI({
                partnerId,
                requestId,
                access_token,
            });
            return {
                // accessToken,
                phoneNumber: data?.call_detail?.callback_number || '',
                access_token,
                ...data,
            };
        } catch (error) {
            if (error?.response?.status === 500) {
                const errorStatus = error?.response?.status;
                throw errorStatus;
            }
            if (error?.response?.status === 422) {
                const errorStatus = error?.response?.status;
                throw errorStatus;
            }
            const errorMsg =
                (error?.response?.data?.data?.partner_short_id?.join('\n') ||
                    '') +
                (error?.response?.data?.data?.request_id?.join('\n') || '');
            throw errorMsg || error.message;
        }
    };

    const fetchCallDetails = async (partnerId, callId) => {
        try {
            const response = await fetchJitAccessTokenAPINew({ partnerId });
            const accessToken = _get(response, 'data.token', '');
            // const partner = await getPartnerAPI({ accessToken, partnerId });
            const call = await getCallAPI({ accessToken, partnerId, callId });
            return _get(call, 'data', {});
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error fetching data:', error);
            throw error;
        }
    };
    const apiValue = useMemo(() => ({ fetchData, fetchCallDetails }), []);

    return (
        <ApiContext.Provider value={apiValue}>{children}</ApiContext.Provider>
    );
}

export default ApiProvider;
